import { schema } from 'normalizr';

export const product = new schema.Entity('products');
export const subject = new schema.Entity('subjects');
export const bank = new schema.Entity('banks');
export const district = new schema.Entity('districts');
export const invoice = new schema.Entity('invoices');
export const newsItem = new schema.Entity('news');

export const meta = new schema.Entity('meta', {
  subjects: [subject],
  banks: [bank],
  districts: [district]
});


export const object = new schema.Entity('objects', {
  products: [product]
});


export const cartItem = new schema.Entity('cartItem', {
  product: product,
  subject: subject
});


export const cart = new schema.Entity(
  'cart',
  {items: [cartItem]},
  {idAttribute: () => 'cart'}
);


// WEBPACK FOOTER //
// ./src/schema.js